import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CompanyAndFeature } from '../../../../shared/interfaces/buyer-config.interface';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { Configuration, Enable } from './config-enable';

/**
 * Directive for automatically showing and hiding content based on the user's config settings
 * Like advance targeting questions can be added only when buyer has advanceTarget config settings enabled
 * Similar to *ngIf="config === advanceTarget" but without needing to pull in the auth service
 */
@Directive({
  selector: '[psUiConfigEnabled]',
})
export class ConfigEnabledDirective {
  private _hasView = false;

  constructor(
    private _authService: AuthService,
    private _viewContainer: ViewContainerRef,
    private _templateRef: TemplateRef<any>
  ) {}

  _render() {
    if (this._hasView) {
      this._viewContainer.clear();
      this._viewContainer.createEmbeddedView(this._templateRef);
      return;
    }
    this._viewContainer.clear();
  }

  @Input() set psUiConfigEnabled(config: string | CompanyAndFeature) {
    const configFinal = Configuration.extract(config);
    const userType = this._authService.serviceBuyer?.token
      ? 'buyer'
      : this._authService.userType;
    this._hasView = new Enable(userType, configFinal).handle(
      this._authService.allBuyerConfigs,
      this._authService.buyerConfig!
    );
    this._render();
  }
}
